'use strict';

function ResetPassword() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this._analytics = new Analytics();
  this.extends = [_Secured, _AnalyticsData];
  this._submitButton = null;
  this._reset_password_token = null;

  this.init = function () {
    if (this._session.getAuthToken() !== '') {
      window.location.replace(this._DEFAULT_LOGGEDIN_PATH);
    }
    this._validateResetToken();

    var schemaReq = new APIRequest('/schemas?filter=reset_password', 'GET', null, $.proxy(this._onGetSchema, this));
    schemaReq.send();

    this._analytics.update(this.analyticsData, this);

    this._disableSubmitOnEnter();
  };

  this.initAllReady = function () {
    this._submitButton = $('.button', this.node).show();
    $(this.node).off('keyup.blocksubmit keypress.blocksubmit keydown.blocksubmit');
  };

  this._validateResetToken = function () {
    var reset_password_token = getURLParameter('token').replace(/ /g, '');
    if (reset_password_token === '') {
      console.error('reset password token is required');
    } else {
      var validate = new APIRequest('/accounts/password_token/' + reset_password_token, 'GET', {}, $.proxy(this._onValidateToken, this));
      validate.send();
    }
  };

  this._redirect_invalid_token = function () {
    return window.location.replace('/login?notification=already-verified');
  };

  this._onValidateToken = function (data, response) {
    if (response == 200) {
      this._reset_password_token = data.reset_password_token;
      $('#reset_password_token').val(this._reset_password_token);
    } else {
      this._setButtonLoadState(false);
      this._redirect_invalid_token();
    }
  };

  this._onGetSchema = function (data, response, status) {
    if (response == 200) {
      var schema = JSON.parse(data[0].schema);

      $('form', this.node).mogo().create('SchemaValidation', {
        schema: schema,
        onSubmit: this._onValidate.bind(this)
      });
    } else {
      this._setButtonLoadState(false);
    }
  };

  this._setButtonLoadState = function (disabled) {
    if (disabled) {
      this._submitButton.mogo().setDisabledLoadState();
    } else {
      this._submitButton.mogo().removeDisabledLoadState();
    }
  };

  this._disableSubmitOnEnter = function () {
    // don't let users submit the form using the enter key until we ready.
    $(this.node).on('keyup.blocksubmit keypress.blocksubmit keydown.blocksubmit', function (e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode === 13) {
        e.preventDefault();
        return false;
      }
    });
  };

  this._onValidate = function (resultObj) {
    this._setButtonLoadState(true);
    if (resultObj.count == 0) {
      var formAnalyticsID = $('form', this.node).data('analytics-id');
      var data = {
        password: $('#password').val(),
        reset_password_token: this._reset_password_token
      };
      var request = new APIRequest('/accounts/reset_password', 'POST', data, $.proxy(this._onResetPassword, this));
      request.send();

      this._analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });
    } else {
      // - user has left the password field empty
      this._setButtonLoadState(false);
    }
    return false;
  };

  this._onResetPassword = function (data, response) {
    if (response == 200) {
      this._session.setAuthToken(data.auth_token);
      location.replace(this._DEFAULT_LOGGEDIN_PATH + '?notification=password-changed');
    } else if (data.errors[0].key == 'no_reset_password_requested') {
      this._redirect_invalid_token();
    } else {
      this._setButtonLoadState(false);
      $('#Notification').mogo().get();
    }
  };
}